import { gql } from '@grandvisionhq/graphql';
import AccountAppointmentFragment from '../fragments/appointment.js';

const GET_APPOINTMENT_BY_ID = gql`
  query getAppointmentById($id: ID!) {
    appointment(id: $id) {
      ...AccountAppointmentFragment
    }
  }
  ${AccountAppointmentFragment}
`;

export { GET_APPOINTMENT_BY_ID };
//# sourceMappingURL=get-appointment-by-id.js.map
